export const toUppercase = (str?: string) => {
  return (str || "").toUpperCase();
};

export const capitalizeFirstWord = (str: string, lower = true) => {
  return (lower ? str.toLowerCase() : str).replace(/(?:^|\s)\S/, a => {
    return a.toUpperCase();
  });
};
export const capitalizeAllWords = (str: string, lower = true) => {
  return (lower ? str.toLowerCase() : str).replace(/(?:^|\s)\S/g, a => {
    return a.toUpperCase();
  });
};
export const generateUUID = () => {
  const crypto = window.crypto || window.msCrypto;
  return crypto.randomUUID();
};
